import {
  ApiReducer,
  makeApiAction,
  makeApiReducer,
  RsaaTypes,
} from '../../../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../../../core/redux/IAppState';

import { RedemptionType } from '../redemptionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../../../core/redux/api/module';
import { API_GET_ENTITLEMENT_REDEMPTION_TYPES } from '../../../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../../../core/redux/api/circuitBreaker/module';
import { assoc } from '../../../../language/module';
import { getResource } from '../../../../language/resources/getResource';


const KEY_ACTION = ACTION_TYPE.GET_ALL_REDEMPTION_TYPES_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_ALL_REDEMPTION_TYPES_REQUEST,
  ACTION_TYPE.GET_ALL_REDEMPTION_TYPES_RESPONSE,
  ACTION_TYPE.GET_ALL_REDEMPTION_TYPES_ERROR,
];

/**
 * An action to dispatch to get the complete list of Resort Tools redemption types
 */
export const getRedemptionTypesAction = () => makeApiAction(
  {
    method:   'GET',
    headers:  (state: IAppState) => ({
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: API_GET_ENTITLEMENT_REDEMPTION_TYPES,
    types:    ACTIONS.map(action => ({ type: action })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION) || !!getLoading(state, KEY_ACTION, KEY_ACTION),
  },
);


const reducer: ApiReducer<RedemptionType[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error || !payload) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error || getResource(state.locale, 'VIEW_DAYS_FAILED_FETCH_ERROR'));
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('redemptionTypes', payload, noLoadingOrError);
};


export const getRedemptionTypesReducer = makeApiReducer<RedemptionType[]>(ACTIONS, KEY_ACTION, reducer);
